import { cx } from "@jugl-web/utils";
import { FC } from "react";
import { ReactComponent as ChevronIcon } from "./assets/chevron.svg";

interface ProductVariantSelectProps {
  label: string;
  options: {
    id: string;
    label: string;
    isDisabled: boolean;
  }[];
  selectedOption: string | null;
  onSelect: (option: string) => void;
}

export const ProductVariantSelect: FC<ProductVariantSelectProps> = ({
  label,
  options,
  selectedOption,
  onSelect,
}) => {
  const hasSelectedOption = selectedOption !== null;

  return (
    <div className="flex flex-col gap-1">
      <span className="px-2 font-secondary text-[13px] leading-[140%] font-normal text-dark-700">
        {label}:
      </span>
      <div className="relative flex h-[42px] items-center overflow-hidden rounded-[10px] border border-solid border-grey-300 bg-white transition-colors hover:bg-grey-100">
        <select
          value={selectedOption ?? ""}
          onChange={(e) => onSelect(e.target.value)}
          className={cx(
            "h-full w-full appearance-none border-0 bg-transparent pr-10 pl-4 font-secondary text-sm leading-[160%] outline-none",
            hasSelectedOption
              ? "font-medium text-dark"
              : "font-normal text-dark-600"
          )}
        >
          {!hasSelectedOption && (
            <option value="" disabled>
              Select
            </option>
          )}
          {options.map((option) => (
            <option
              key={option.id}
              value={option.id}
              disabled={option.isDisabled}
            >
              {option.label}
            </option>
          ))}
        </select>
        <ChevronIcon className="pointer-events-none absolute right-3" />
      </div>
    </div>
  );
};
